'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _TallyLoaderUtil = require('./TallyLoaderUtil');

var _TallyLoaderUtil2 = _interopRequireDefault(_TallyLoaderUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var util = new _TallyLoaderUtil2.default();

var TallyLoader = function (_Component) {
  _inherits(TallyLoader, _Component);

  function TallyLoader() {
    _classCallCheck(this, TallyLoader);

    return _possibleConstructorReturn(this, (TallyLoader.__proto__ || Object.getPrototypeOf(TallyLoader)).apply(this, arguments));
  }

  _createClass(TallyLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onLoad = _props.onLoad,
          portals = _props.portals;

      // If we on local and local is diabled, return

      if (!enviro.deployed() && util.isTallyDisabledLocally()) {
        return;
      }

      // Get the correct tally portal
      var portal = util.getPortal(portals);
      if (!portal) {
        return;
      }

      var src = util.getTallySrc(portal);
      var id = util.getTallyId(portal);

      if (util.doesTallyAlreadyExist(id)) {
        return;
      }

      util.addTallyScriptToPage(id, src, onLoad);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return TallyLoader;
}(_React.Component);

exports.default = TallyLoader;
;

TallyLoader.propTypes = {
  onLoad: _React.PropTypes.func,
  portal: _React.PropTypes.object
};

TallyLoader.defaultProps = {
  onLoad: null,
  portals: {
    prod: 430057,
    qa: 27156
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/tally-loader-react/static-1.63/js/TallyLoader.js
// module id = 276
// module chunks = 0